/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-tabs */
/* eslint-disable spaced-comment */
/* eslint-disable indent */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from "react";
import PropTypes from "prop-types";
import "./LoginBanner.scss";

import t from "../../../utils/translation/translator";

const LoginBanner = ({ mySchneiderLink, ...props }) => {
  return (
    <div className="Banner login-banner p-4" {...props}>
      <div data-testid="login-banner-actions" className="flex-col">
        <qds-title class="banner-title" layer="panel" level="root" data-testid="login-banner-title" alignment="center">
          <strong>{t("msizer.core.banner.title")}</strong>
        </qds-title>
        <div className="justify-self-center">
          <qds-button
            data-testid="login-banner-action-button"
            class="banner-button"
            importance="emphasized"
            href={mySchneiderLink}
            size="standard"
            text={t("msizer.core.banner.login-register")}
          ></qds-button>
        </div>
        <qds-title
          class="banner-title"
          data-testid="login-banner-subtitle"
          layer="panel"
          level="section"
          alignment="center"
        >
          <strong>{t("msizer.core.banner.subtitle")}</strong>
        </qds-title>
      </div>
      <div data-testid="login-banner-sections" className="login-banner-sections flex p-2">
        <div data-testid="login-banner-section-save" className="flex-1 flex">
          <qds-icon class="banner-icon" name="arrow-down-tray" library="default"></qds-icon>
          <div>{t("msizer.core.banner.section.save")}</div>
          {/* <qds-title
            layer="panel"
            level="subsection"
            alignment="start"
            icon-name="arrow-down-tray"
            icon-library="default"
          >
            {t("msizer.core.banner.section.save")}
          </qds-title> */}
        </div>
        <div data-testid="login-banner-section-discovery" className="flex-1 flex">
          <qds-icon
            // importance="subdued"
            // size="medium"
            class="banner-icon"
            name="spanner-hammer"
            library="default"
            // backgound-color="standard"
          ></qds-icon>
          <div>{t("msizer.core.banner.section.discover")}</div>
          {/* <qds-title
            layer="panel"
            level="subsection"
            alignment="start"
            icon-name="spanner-hammer"
            icon-library="default"
          >
            {t("msizer.core.banner.section.discover")}
          </qds-title> */}
        </div>
        <div data-testid="login-banner-section-find" className="flex-1 flex">
          <qds-icon
            class="banner-icon"
            importance="standard"
            size="xlarge"
            name="list-bullets"
            library="default"
          ></qds-icon>
          <div>{t("msizer.core.banner.section.find")}</div>
          {/* <qds-title
            layer="panel"
            level="subsection"
            alignment="start"
            icon-name="list-bullets"
            icon-library="default"
          >
            {t("msizer.core.banner.section.find")}
          </qds-title> */}
        </div>
      </div>
    </div>
  );
};

export default LoginBanner;

LoginBanner.propTypes = {
  mySchneiderLink: PropTypes.string
};

LoginBanner.defaultProps = {
  mySchneiderLink: ""
};
